export default __webpack_public_path__ + "static/media/googlePlay.8725e54b.svg";